import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { getMarketPlaceAgencies } from 'features/views/settings/marketPlaceAgencies/selectors';

import Agency from './Agency';

export const Agencies = () => {
	const agencies = useSelector(getMarketPlaceAgencies);

	return (
		<Paper sx={{ p: 2, borderRadius: 2, backgroundColor: (theme) => theme.palette.background[100] }}>
			<ComponentLoader fetchStorePath={fetch.constants.urls.settingsMarketPlaceAgencies}>
				<Grid container spacing={2}>
					{!isNilOrEmpty(agencies) &&
						agencies.map((agency) => (
							<Grid size={6}>
								<Agency agency={agency} />
							</Grid>
						))}
				</Grid>
			</ComponentLoader>
		</Paper>
	);
};

export default Agencies;
